export const productModelToHousingShape = {
	Column: 'Column',
	Twist06: 'ColumnTwist06',
	Twist12: 'ColumnTwist12',
	Bollard: 'Bollard',
	PoleTop: 'PoleTop',
	PoleLateral: 'PoleLateral',
	WallSurface: 'WallSurface',
	WallRecessed: 'WallRecessed',
};
